import React, { useState, useEffect } from "react";

// Invite codes — add/remove as needed, or set REACT_APP_INVITE_CODES env var (comma-separated)
const VALID_CODES = (process.env.REACT_APP_INVITE_CODES || "PAYMAP2026,EARLYBIRD")
  .split(",")
  .map((c) => c.trim().toUpperCase());

const InviteGate = ({ children }) => {
  const [granted, setGranted] = useState(false);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (localStorage.getItem("paymap_access") === "granted") {
      setGranted(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (!code.trim()) {
      setError("Please enter an invite code.");
      return;
    }
    if (VALID_CODES.includes(code.trim().toUpperCase())) {
      localStorage.setItem("paymap_access", "granted");
      setGranted(true);
    } else {
      setError("Invalid invite code.");
    }
  };

  if (granted) return children;

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
      fontFamily: "Inter, system-ui, sans-serif",
    }}>
      <div style={{
        background: "#fff",
        borderRadius: 16,
        padding: "48px 36px",
        maxWidth: 400,
        width: "100%",
        boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
        textAlign: "center",
      }}>
        <div style={{ fontSize: "2rem", fontWeight: 900, marginBottom: 8 }}>
          <span style={{ color: "#1F2937" }}>Pay</span>
          <span style={{ color: "#2563EB" }}>Map</span>
        </div>
        <p style={{ color: "#64748b", fontSize: "1rem", marginBottom: 24 }}>
          Enter your invite code to continue
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Invite Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            autoFocus
            autoComplete="off"
            style={{
              width: "100%",
              padding: "14px",
              fontSize: "1rem",
              border: "2px solid #e0e7ef",
              borderRadius: 8,
              marginBottom: 14,
              background: "#f8fafc",
              outline: "none",
              boxSizing: "border-box",
              textAlign: "center",
              letterSpacing: "0.15em",
            }}
          />
          {error && (
            <div style={{
              color: "#e11d48",
              background: "#fef2f2",
              border: "1px solid #fecdd3",
              borderRadius: 6,
              padding: "8px 12px",
              marginBottom: 12,
              fontSize: "0.95rem",
            }}>{error}</div>
          )}
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "14px",
              fontSize: "1.05rem",
              background: "linear-gradient(90deg, #2563EB 0%, #1F2937 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Enter
          </button>
        </form>
      </div>
    </div>
  );
};

export default InviteGate;
